module.exports = __webpack_public_path__ + "img/logoshree.dc724f50.png";